var map = {
	"app/about/about.module": [
		"./src/app/about/about.module.ts",
		"app-about-about-module"
	],
	"app/reports/add-specimen-report/add-specimen-report.module": [
		"./src/app/reports/add-specimen-report/add-specimen-report.module.ts",
		"app-reports-add-specimen-report-add-specimen-report-module"
	],
	"app/services/services.module": [
		"./src/app/services/services.module.ts",
		"app-services-services-module"
	],
	"app/specimen-nxt-stage/specimen-nxt-stage.module": [
		"./src/app/specimen-nxt-stage/specimen-nxt-stage.module.ts",
		"app-specimen-nxt-stage-specimen-nxt-stage-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;